module.exports = __webpack_public_path__ + "img/image.eb57af2a.svg";